import type { AjudaDaPagina, ChaveDePagina } from "./tipos";

export const AJUDA_DO_LABORATORIO = {
  "lab-cadastros": {
    titulo: "Cadastros",
    resumo: "Os dentistas, laboratórios, radiologias, redes de clínicas e fornecedores com quem o laboratório trabalha.",
    passos: [
      "Para cadastrar: clique em Novo cadastro, escolha o tipo e preencha os dados.",
      "Para o parceiro entrar pela plataforma: clique em Convidar parceiro e envie o convite.",
      "Para aceitar uma clínica que pediu conexão: use os pedidos de conexão que aparecem acima da lista.",
      "Para filtrar: use as abas Todos, Dentistas, Laboratórios, Radiologias, Rede e Fornecedores, e a busca.",
      "Para editar: clique no cadastro.",
    ],
    dicas: [
      "Novo cadastro só aparece para quem pode editar cadastros; o convite fica com quem gerencia parceiros.",
      "Exportar gera uma planilha com os cadastros.",
    ],
  },
  "lab-catalogo": {
    titulo: "Catálogo",
    resumo: "O resumo do que está ativo no catálogo do laboratório: é o que os dentistas escolhem ao fazer um pedido.",
    passos: [
      "Para os serviços: clique no cartão Serviços para ativar, desativar ou criar os seus.",
      "Para os materiais: clique em Materiais e deixe ativos só os que o laboratório trabalha.",
      "Para as cores: clique em Cores para organizar as escalas e opções de cor.",
      "Para os preços: clique em Preços para definir os valores dos serviços e materiais.",
      "Para mandar o catálogo a um dentista: clique em Compartilhar catálogo e copie o link público (ou baixe o QR). Ali também aparece se o link mostra preços e o atalho para configurá-lo.",
    ],
    dicas: [
      "Insumos e preços de compra ficam em Estoque, não no catálogo.",
      "Quem só pode ver preços entra direto na seção Preços.",
    ],
  },
  "lab-catalogo-visualizar": {
    titulo: "Visualização do catálogo",
    resumo: "O catálogo como o dentista vê: é o que sai no PDF e no link público (o do QR).",
    passos: [
      "Para baixar o PDF: clique em Baixar PDF e escolha Salvar como PDF como destino da impressão.",
      "Para escolher se os preços aparecem no PDF: use Com preços ou Sem preços no topo. O link público segue a escolha feita em Configurações › Perfil público, que o Compartilhar catálogo mostra.",
      "Para mandar o link público: clique em Compartilhar catálogo e copie, abra ou baixe o QR.",
      "Para deixar com a cara do laboratório: clique em Personalizar e escolha a cor de destaque, o fundo, a capa (na cor ou com uma imagem sua), os contatos do rodapé e o que mostrar. A visualização muda na hora; clique em Salvar aparência para valer no PDF e no link público.",
    ],
    dicas: [
      "Personalizar o catálogo é do plano pago. Sem ele, o catálogo sai no visual padrão.",
      "Se o PDF sair sem as cores de fundo, marque Gráficos de segundo plano nas opções da impressão.",
      "A capa ocupa a primeira página do PDF; no link público ela aparece como um destaque no topo.",
      "No link público, o dentista tem Quero trabalhar com este laboratório e Pedir em cada serviço. O pedido de conexão chega em Cadastros para vocês aceitarem; quem já é cliente pede com os preços combinados com a clínica dele.",
    ],
  },
  "lab-catalogo-gerenciar": {
    titulo: "Catálogo",
    resumo: "Serviços, materiais, equipamentos, cores e preços do laboratório, uma seção por vez. É o que aparece em todo pedido feito com vocês.",
    passos: [
      "Para trocar de seção: use o menu ao lado (no celular, as abas): Serviços, Materiais, Equipam., Cores e Preços.",
      "Em Serviços aparecem só os que o laboratório oferece. Para incluir um: Adicionar serviço, no topo — procure na base da plataforma (inclusive os que você desligou) ou crie um novo. Desmarcar tira o serviço dos pedidos.",
      "Para conferir como o dentista vê: Visualizar catálogo, ao lado de Adicionar serviço.",
      "Para adicionar uma cor: use o botão Adicionar no fim da lista da seção. A cor já fica disponível nos pedidos.",
      "Para montar o cardápio de materiais: em Materiais, deixe ativo o que o laboratório usa ou crie um material novo.",
      "Para os equipamentos: cadastre a fresadora, a impressora ou o forno para saber quanto de broca cada trabalho consome.",
      "Para os preços: o Catálogo Base é o preço padrão. Crie Tabelas (convênios e parcerias) para reaproveitar entre parceiros, ou use Exceções por Clínica.",
    ],
    dicas: ["Mudar preço exige a permissão de editar preços e pede o PIN de segurança."],
  },
  "lab-comecar": {
    titulo: "Montar catálogo",
    resumo: "Os primeiros passos do laboratório novo: escolher os serviços, os materiais de cada um e confirmar.",
    passos: [
      "Passo 1, Serviços: abra uma categoria e toque nos serviços que você faz. Se faltar algum, use + Adicionar dentro da própria categoria.",
      "Passo 2, Configurar: toque em cada serviço para conferir dente ou arcada, os materiais e as escalas de cor. Depois de visto, o serviço fica verde.",
      "Passo 3, Confirmar: revise e clique em Concluir. O catálogo é gravado de uma vez e você vai para o Início.",
    ],
    dicas: [
      "Nada é gravado até Concluir, mas o que você marcou fica guardado neste navegador se sair no meio.",
      "Preços e ajustes finos ficam depois em Catálogo.",
      "Criou o laboratório por engano? Use Cancelar criação no topo: enquanto ele estiver vazio, é descartado e você volta para a organização anterior.",
    ],
  },
  "lab-estoque": {
    titulo: "Estoque",
    resumo: "Os insumos do laboratório: o que comprar, quanto há, o que entrou e saiu e o cadastro de cada insumo.",
    passos: [
      "Para saber o que comprar: a aba Comprar mostra o que está acabando, com o consumo e quando acaba.",
      "Para registrar uma compra: clique em Registrar entrada, adicione os insumos com quantidade e preço e salve. A compra entra no financeiro como conta a pagar.",
      "Para acertar o saldo depois de contar: em Saldos, use Informar saldo contado.",
      "Para ver o que entrou e saiu: abra Movimentos (ou Ver os lançamentos, em Saldos) e confira compras, consumos e ajustes.",
      "Para cadastrar insumos: na aba Insumos, use Novo insumo e defina unidade, estoque mínimo e preço de compra.",
    ],
    dicas: ["Só quem tem a permissão de estoque vê esta página."],
  },
  "lab-producao": {
    titulo: "Produção",
    resumo: "Os trabalhos em andamento dos pedidos aceitos, por estágio ou em planilha.",
    passos: [
      "Para acompanhar: alterne entre Estágios (quadro por etapa) e Planilha.",
      "Para avançar um trabalho: arraste o cartão para o próximo estágio, ou abra o serviço e use Alterar estágio.",
      "Para ver só o seu: ative Meus trabalhos. Para refinar, abra Filtros (clínica, dentista, retrabalho e estágio interno).",
      "Para delegar: abra o serviço e use Alterar responsável.",
      "Para encerrar: use Finalizar serviço e escolha como ele termina.",
      "Para montar as etapas do laboratório: clique em Configurar e crie ou reordene os estágios.",
    ],
    dicas: [
      "Configurar e as ações que mudam a produção exigem a permissão de avançar a produção.",
      "Etiquetas e recibos saem pelo menu Imprimir do pedido.",
      "Quem não pode ver toda a produção vê só os trabalhos delegados a si.",
      "A planilha da produção leva o nome dos pacientes: exportar é uma permissão à parte, ligada por padrão só para o proprietário e o administrador.",
    ],
  },
  "lab-pedidos": {
    titulo: "Pedidos",
    resumo: "Os pedidos recebidos das clínicas conectadas: aceitar ou recusar, acompanhar e consultar os concluídos.",
    passos: [
      "Para decidir um pedido novo: na aba Pendentes, clique em Aceitar (vai para a produção) ou Recusar (a clínica recebe o motivo).",
      "Para acompanhar: em Em produção, use Todos, Parcial ou Nada pronto para ver quanto de cada pedido já está pronto.",
      "Para ver o detalhe: clique no pedido ou em Ver pedido completo.",
      "Para o histórico: Concluídos mostra o que já saiu; Recusados reúne os recusados e os cancelados.",
      "Para mudar a visualização: alterne entre Cards e Lista.",
    ],
    dicas: [
      "Se estiver ligado em Configurações › Etiquetas, aceitar o pedido já abre a impressão das etiquetas.",
      "Aceitar e recusar exigem a permissão de aceitar pedidos e avançar a produção.",
      "Os selos Urgente e Vence em breve destacam o que pede atenção.",
      "Com a taxa de urgência configurada em Configurações › Dados, aceitar um pedido Urgente oferece \"Cobrar taxa de urgência\" já marcado; desmarque para dispensar.",
      "A planilha dos pedidos leva o nome dos pacientes: exportar é uma permissão à parte, ligada por padrão só para o proprietário e o administrador.",
    ],
  },
  financeiro: {
    titulo: "Financeiro",
    resumo: "Entradas, saídas e resultado do laboratório, mês a mês. As receitas dos pedidos entram sozinhas.",
    passos: [
      "Para ver como foi o mês: a aba Visão do mês mostra faturamento, custos, margem, resultado e fluxo de caixa. Troque o mês no seletor ao lado das abas.",
      "Para cobrar os clientes: em Cobranças, use Fechar e enviar para emitir os extratos e mandar por e-mail; ao receber, abra o extrato e use Registrar recebimento.",
      "Para contas e custos fixos: em Contas a pagar, veja as contas por vencimento e cadastre custos fixos (aluguel, salários), que aparecem todo mês.",
      "Para lançar o que o sistema não sabe: em Lançamentos, crie um lançamento de entrada ou de saída.",
      "Para notas fiscais: em Notas fiscais, registre a nota e anexe o XML, o PDF ou uma foto. A nota não é emitida por aqui. No Novo lançamento dá para anexar a nota junto: o XML preenche valor, mês e fornecedor.",
      "Para trazer o histórico de compras: em Notas fiscais › Importar notas, escolha os XMLs (ou a pasta) das notas de fornecedor. Cada nota é registrada com o arquivo e vira despesa já paga na data dela; fornecedor que não está nos Cadastros é cadastrado pelo CNPJ. Mês fechado recebe só a nota. Recebeu um .zip do contador? Descompacte antes.",
      "Para configurar os extratos, fechar o mês e organizar as categorias: use a aba Configurações.",
    ],
    dicas: [
      "Mês fechado não aceita lançamento novo nem edição; só o proprietário reabre.",
      "É um recurso do plano pago, visível para o proprietário, os sócios e quem tiver a permissão do financeiro.",
    ],
  },
} satisfies Partial<Record<ChaveDePagina, AjudaDaPagina>>;
